import * as yup from "yup";

export const useEmployeeValidation = () => {
  return yup.object({
    jobType: yup.object().shape({
      id: yup.string().required("Παρακαλώ επιλέξτε Ιδιότητα"),
    }),
  });
};
